import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  container: {
    position: 'relative'
  },

  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    marginLeft: ({ depth }) => `${(depth + 1) * 13}px`
  },

  drag: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '8px',
    cursor: 'grab'
  },

  emptyDrag: {
    width: '16px',
    marginRight: '8px'
  },

  arrow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: '5px',
    width: '16px',
    height: '16px'
  },

  loading: {
    width: '8px !important',
    height: '8px !important',
    color: theme.palette.primary.main
  },

  expandArrow: {
    cursor: 'pointer'
  },

  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginRight: '8px',
    width: '16px',
    height: '16px'
  },

  titleArea: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: '1px solid transparent',
    boxSizing: 'border-box',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    cursor: 'pointer'
  },

  menu: {
    position: 'absolute',
    top: '50%',
    right: '0',
    display: 'flex',
    alignItems: 'center',
    padding: '2px 4px',
    transform: 'translateY(-50%)',
    '& svg': {
      width: 14,
      height: 14
    }
  },

  selected: {
    color: theme.palette.primary.main,

    '& svg > path': {
      fill: theme.palette.primary.main
    }
  },

  titleSelected: {
    color: theme.palette.primary.main
  },

  count: {
    marginLeft: '4px'
  },

  drop: {
    position: 'absolute',
    left: '13px',
    borderTop: '1px solid transparent',
    borderBottom: '1px solid transparent',
    boxSizing: 'border-box',
    width: 'calc(100% - 16px)',
    height: '20px'
  },

  dropTop: {
    top: '-7px',
    height: '7px',
    borderTopColor: ({ isOverTop }) =>
      isOverTop ? theme.palette.primary.main : 'transparent'
  },

  dropBottom: {
    bottom: '6px',
    height: '9px',
    borderBottomColor: ({ isOverBottom }) =>
      isOverBottom ? theme.palette.primary.main : 'transparent'
  }
}))

export default useStyles
